import { ConfigProperties } from 'src/app/shared/models/config';

export class ConfigDHL implements ConfigProperties {
    constructor(
        public showBreadcrumbs = true,
        public defaultAWBPrefix = '403',
        public allowContinueWithAWBNotFound = true,
        public allowAWBSubscription = false,
        public forceToRequestDestination = true,
        public allowPaymentsWithoutISCPaid = true,
        public maxItemsPerCart = 10,
        public enableSearchButtonOutside = false,
        public searchAWBLabel = 'Enter your Master Air Waybill',
        public labelAWB = 'Air waybill',
        public labelHAWB = 'House Air waybill',
        public minimumAmountAllowed = 1,
        public allowPaymentsWithoutShipmentInformation = true,
        public allowedDestinations = ['CVG'],
        public enableDarkMode = false,
        public disableChargeButtonWhenStatusDLV = true
    ) {}
}
